import { useIntl } from 'react-intl';
import { getLocalizedValue } from './localizationUtils';

/**
 * Hook that returns a getLocalizedValue function using the current UI locale
 */
export function useLocalization() {
  const intl = useIntl();
  const locale = intl.locale;

  return {
    getLocalizedValue: (array) => getLocalizedValue(array, locale),
    locale,
  };
}

export default useLocalization;
